import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { MsalGuard } from '@azure/msal-angular';


const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled'
};

const routes: Routes = [
    {
        path: 'app-layout',
        component: AppLayoutComponent,
        children: [
            { path: 'dash', loadChildren: () => import('./main/components/deutsch-dashboard/deutsch-dashboard.module').then(m => m.DeutschDashboardModule), canActivate: [MsalGuard] },
            { path: 'M-global-view', data: { breadcrumb: "Fiche Apprenant", fragment: 'assets/demo/images/360-degrees.png' }, loadChildren: () => import('./main/components/m-global-vue/m-global-vue.module').then(m => m.MGlobalVueModule), canActivate: [MsalGuard] },
            { path: 'M-purchase', data: { breadcrumb: "Opération d'achat", fragment: 'assets/demo/images/management.png' }, loadChildren: () => import('./main/components/purcahses-operations/purcahses-operations.module').then(m => m.PurcahsesOperationsModule), canActivate: [MsalGuard] },
            { path: 'M-config', data: { breadcrumb: "Configuration de la plateforme", fragment: 'assets/demo/images/gear.png' }, loadChildren: () => import('./main/components/m-configuration/m-configuration.module').then(m => m.MConfigurationModule), canActivate: [MsalGuard] },
            { path: 'M-Formation', data: { breadcrumb: "Gestion des Sessions", fragment: 'assets/demo/images/gear.png' }, loadChildren: () => import('./main/components/formation/formation.module').then(m => m.FormationModule), canActivate: [MsalGuard] },
            { path: 'M-Registations', data: { breadcrumb: "Module Inscriptions", fragment: 'assets/demo/images/registration.png' }, loadChildren: () => import('./main/components/registration/registration.module').then(m => m.RegistrationModule), canActivate: [MsalGuard] },
            { path: 'M-Finance', data: { breadcrumb: "Suivi Financier", fragment: 'assets/demo/images/money-bag-c.png' }, loadChildren: () => import('./main/components/finance-module/finance-module.module').then(m => m.FinanceModuleModule), canActivate: [MsalGuard] },

        ]
    },
    { path: '', loadChildren: () => import('./main/components/landing/landing.module').then(m => m.LandingModule) },
    { path: 'notfound', loadChildren: () => import('./main/components/notfound/notfound.module').then(m => m.NotfoundModule) },
    { path: 'access-denied', loadChildren: () => import('./main/components/access-denied/access-denied.module').then(m => m.AccessDeniedModule) },
    { path: 'offline-exception', loadChildren: () => import('./main/components/offline-exception/offline-exception.module').then(m => m.OfflineExceptionModule) },
    { path: '**', redirectTo: '/notfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
